/* SHOPYTHON homepage line-art layer: a tiny 3D line renderer on a fixed canvas.
   Needs GSAP + ScrollTrigger + Lenis (loaded by sections/scroll-film.liquid); degrades to rAF without them. */
(function(){
'use strict';
if (window.__laHome) return; window.__laHome = true;
const ART = (() => {
  const TAU = Math.PI * 2;
  const centroid = pts => { let x=0,y=0,z=0; for (const p of pts){x+=p[0];y+=p[1];z+=p[2];} const n=pts.length||1; return [x/n,y/n,z/n]; };
  const newell = (vs, f) => {
    let nx=0,ny=0,nz=0;
    for (let i=0;i<f.length;i++){ const a=vs[f[i]], b=vs[f[(i+1)%f.length]];
      nx+=(a[1]-b[1])*(a[2]+b[2]); ny+=(a[2]-b[2])*(a[0]+b[0]); nz+=(a[0]-b[0])*(a[1]+b[1]); }
    const l=Math.hypot(nx,ny,nz)||1; return [nx/l,ny/l,nz/l];
  };

  function part(verts, faces, o = {}) {
    if (faces.length) {
      const c = centroid(verts);
      faces = faces.map(f => {
        const n = newell(verts, f), fc = centroid(f.map(i => verts[i]));
        return ((fc[0]-c[0])*n[0] + (fc[1]-c[1])*n[1] + (fc[2]-c[2])*n[2]) < 0 ? f.slice().reverse() : f;
      });
    }
    const map = new Map();
    faces.forEach((f, fi) => { for (let k=0;k<f.length;k++){ const a=f[k], b=f[(k+1)%f.length];
      const key = a<b ? a*100000+b : b*100000+a; let e = map.get(key);
      if (!e){ e = {a, b, f:[]}; map.set(key, e); } e.f.push(fi); } });
    const edges = [...map.values()];
    const nrm = faces.map(f => newell(verts, f));
    const crease = o.crease ?? 0.9;
    edges.forEach(e => { e.hard = e.f.length < 2 || (nrm[e.f[0]][0]*nrm[e.f[1]][0] + nrm[e.f[0]][1]*nrm[e.f[1]][1] + nrm[e.f[0]][2]*nrm[e.f[1]][2]) < crease; });
    const faceEdges = faces.map(() => []);
    edges.forEach((e, ei) => e.f.forEach(fi => faceEdges[fi].push(ei)));
    return { verts, faces, edges, faceEdges, wires: o.wires || [], open: !!o.open, accent: !!o.accent, spin: o.spin || null,
             sx: new Float32Array(verts.length), sy: new Float32Array(verts.length), sz: new Float32Array(verts.length),
             facing: new Int8Array(faces.length) };
  }
  const axisMap = (a, u, b, axis) => axis === 'x' ? [u, a, b] : axis === 'z' ? [a, b, u] : [a, u, b];

  /* ---- primitive builders (model units ≈ cm, y up) ---- */
  function box(w, h, d, cx=0, cy=0, cz=0, o) {
    const x=w/2, y=h/2, z=d/2;
    const v = [[-x,-y,-z],[x,-y,-z],[x,y,-z],[-x,y,-z],[-x,-y,z],[x,-y,z],[x,y,z],[-x,y,z]].map(p => [p[0]+cx, p[1]+cy, p[2]+cz]);
    return part(v, [[0,1,2,3],[4,5,6,7],[0,1,5,4],[3,2,6,7],[0,3,7,4],[1,2,6,5]], o);
  }
  // frustum / cylinder along an axis; r1 at the low end, r2 at the high end
  function drum(r1, r2, h, n, cx=0, cy=0, cz=0, axis='y', o={}) {
    const v = [], f = [];
    for (let k=0;k<2;k++) for (let i=0;i<n;i++){ const a=i/n*TAU, r=k?r2:r1;
      const p = axisMap(Math.cos(a)*r, (k?h/2:-h/2), Math.sin(a)*r, axis); v.push([p[0]+cx, p[1]+cy, p[2]+cz]); }
    for (let i=0;i<n;i++){ const j=(i+1)%n; f.push([i, j, n+j, n+i]); }
    if (o.bottom !== false) f.push([...Array(n).keys()]);
    if (o.top !== false) f.push([...Array(n).keys()].map(i => n+i));
    return part(v, f, { ...o, open: o.top === false || o.bottom === false });
  }
  function ellipsoid(rx, ry, rz, cx=0, cy=0, cz=0, n=16, m=10, o) {
    const v = [[cx, cy-ry, cz]], f = [];
    for (let j=1;j<m;j++){ const t=-Math.PI/2 + j/m*Math.PI;
      for (let i=0;i<n;i++){ const a=i/n*TAU; v.push([cx+Math.cos(t)*Math.cos(a)*rx, cy+Math.sin(t)*ry, cz+Math.cos(t)*Math.sin(a)*rz]); } }
    v.push([cx, cy+ry, cz]); const top = v.length-1, ring = j => 1+(j-1)*n;
    for (let i=0;i<n;i++){ const k=(i+1)%n; f.push([0, ring(1)+k, ring(1)+i]); f.push([top, ring(m-1)+i, ring(m-1)+k]); }
    for (let j=1;j<m-1;j++) for (let i=0;i<n;i++){ const k=(i+1)%n; f.push([ring(j)+i, ring(j)+k, ring(j+1)+k, ring(j+1)+i]); }
    return part(v, f, { crease: 0.55, ...o });
  }
  // polyline "wire" parts
  function wire(points, o={}) { return part(points, [], { ...o, wires:[points.map((_,i)=>i)] }); }
  function wires(lines, o={}) { const v=[], w=[]; lines.forEach(l => { const s=v.length; l.forEach(p=>v.push(p)); w.push(l.map((_,i)=>s+i)); }); return part(v, [], { ...o, wires:w }); }
  function circle(r, cx, cy, cz, axis='z', n=28, rb) { const pts=[]; for (let i=0;i<=n;i++){ const a=i/n*TAU; const p=axisMap(Math.cos(a)*r, 0, Math.sin(a)*(rb??r), axis); pts.push([p[0]+cx,p[1]+cy,p[2]+cz]); } return pts; }
  function rect(x0, y0, x1, y1, z) { return [[x0,y0,z],[x1,y0,z],[x1,y1,z],[x0,y1,z],[x0,y0,z]]; }
  function rrect(x0, y0, x1, y1, z, r, n=6) { // rounded rectangle on a front plane
    const pts=[], c=[[x1-r,y1-r,0],[x0+r,y1-r,1],[x0+r,y0+r,2],[x1-r,y0+r,3]];
    c.forEach(([cx,cy,q]) => { for (let i=0;i<=n;i++){ const a=(q*90 + i/n*90)*Math.PI/180; pts.push([cx+Math.cos(a)*r, cy+Math.sin(a)*r, z]); } });
    pts.push(pts[0]); return pts;
  }

  /* ---- the machines ---- */
  const MODELS = {
    spiralMixer() { // Famag / Sunmix style
      const P = [];
      P.push(box(42, 12, 56, 0, 6, 0));                          // base
      P.push(box(30, 58, 24, 0, 41, 16));                        // column
      P.push(box(30, 13, 50, 0, 76, -1));                        // head arm
      P.push(drum(12.5, 16, 24, 30, 0, 26, -12, 'y', { top:false })); // bowl, clear of the column
      P.push(drum(3.2, 3.2, 12, 12, 0, 64, -12));                  // hook shaft collar
      const hook = []; for (let i=0;i<=60;i++){ const t=i/60, a=t*TAU*1.6; hook.push([Math.cos(a)*(3+t*7), 60 - t*38, -12 + Math.sin(a)*(3+t*7)]); }
      P.push(wire(hook, { spin:{ axis:'y', pivot:[0,0,-12], speed:1.4 } }));
      P.push(wires([[[0,58,-12],[0,68,-12]]]));                   // shaft
      P.push(box(6, 4, 1.2, 0, 56, 3.4, { accent:true }));       // switch plate
      P.push(wires([circle(1.6, -8, 52, 3.8, 'z', 16)], { accent:true }));
      return P;
    },
    deckOven() { // Orimas deck
      const P = [], W=120, D=80;
      [0, 1].forEach(k => {
        const y = 52 + k*36;
        P.push(box(W, 34, D, 0, y, 0));
        P.push(wires([rrect(-50, y-12, 26, y+12, -D/2-0.3, 3), rect(-40, y-7, 16, y+5, -D/2-0.3)]));
        P.push(box(62, 2.6, 4, -12, y+14, -D/2-3));             // handle bar
        P.push(wires([circle(2.6, 44, y+6, -D/2-0.3, 'z', 16), circle(2.6, 44, y-5, -D/2-0.3, 'z', 16)], { accent:k===1 }));
      });
      P.push(box(W+4, 4, D+4, 0, 108, 0));                      // top cap
      P.push(box(W, 3, D, 0, 30, 0));                           // stand shelf
      // legs stop at the shelf and carry on above it, so no box runs through another
      [[-56,-36],[56,-36],[-56,36],[56,36]].forEach(([x,z]) => { P.push(box(4, 29.5, 4, x, 13.75, z)); P.push(box(4, 3.5, 4, x, 33.25, z)); });
      return P;
    },
    sheeter() { // Kneader table-top sheeter
      const P = [];
      // an open frame (two side plates + top cover) so the rollers between them can be seen turning
      P.push(box(26, 40, 4, 0, 26, -21));                        // front side plate
      P.push(box(26, 40, 4, 0, 26, 21));                         // back side plate
      P.push(box(26, 6, 46, 0, 49, 0));                          // top cover
      P.push(box(79, 2.4, 38, -45.5, 20, 0));                    // left table, runs in to the rollers
      P.push(box(79, 2.4, 38, 45.5, 20, 0));                     // right table
      P.push(drum(4.6, 4.6, 38, 20, 0, 34, 0, 'z', { spin:{ axis:'z', pivot:[0,34,0], speed:2.2 } }));
      P.push(drum(4.6, 4.6, 38, 20, 0, 23, 0, 'z', { spin:{ axis:'z', pivot:[0,23,0], speed:-2.2 } }));
      P.push(wires([[[-83,18.8,-17],[-83,6,-17]],[[-83,18.8,17],[-83,6,17]],[[83,18.8,-17],[83,6,-17]],[[83,18.8,17],[83,6,17]]]));
      P.push(wires([circle(9, 0, 30, -23.2, 'z', 24)]));
      P.push(wires([[[0,30,-23.4],[0,48,-30],[6,58,-30]]], { accent:true }));
      P.push(wires([circle(2.2, 6, 58, -30, 'z', 12)], { accent:true }));
      return P;
    },
    combi() { // UNOX / EKA combi
      const P = [];
      P.push(box(78, 74, 76, 0, 37, 0));
      P.push(wires([rrect(-36, 5, 20, 68, -38.3, 6), rrect(-28, 13, 12, 60, -38.3, 4)]));
      [20, 28, 36, 44, 52].forEach(y => P.push(wires([[[-26,y,-37],[10,y,-37]]])));      // racks behind glass
      P.push(box(3, 30, 4, 16, 38, -41));                                               // handle
      P.push(wires([rect(25, 50, 36, 64, -38.3)], { accent:true }));                    // display
      P.push(wires([circle(4.2, 30.5, 38, -38.3, 'z', 20)]));                           // knob
      [[-34,-34],[34,-34],[-34,34],[34,34]].forEach(([x,z]) => P.push(drum(1.6, 1.6, 4, 8, x, -2, z)));
      return P;
    },
    standMixer() { // tilt-head stand mixer
      const P = [];
      P.push(box(22, 5, 36, 0, 2.5, 2));
      P.push(box(14, 25, 13, 0, 17.5, 12));                      // column, stops under the head
      P.push(ellipsoid(9, 7.5, 21, 0, 37.7, 0, 16, 10));           // motor head resting on it
      P.push(drum(6.5, 11, 15, 24, 0, 13, -8, 'y', { top:false }));
      const beater = []; for (let i=0;i<=24;i++){ const a=i/24*TAU; beater.push([Math.sin(a)*5, 21 + Math.cos(a)*-7 - 3, -8]); }
      P.push(wire(beater, { spin:{ axis:'y', pivot:[0,0,-8], speed:2.6 } }));
      P.push(wires([[[0,25,-8],[0,30.8,-8]]]));                   // beater shaft up into the head
      P.push(wires([circle(1.6, 7.3, 24, 12, 'x', 12)], { accent:true }));  // speed dial on the column
      return P;
    },
    proofer() {
      const P = [];
      P.push(box(62, 150, 72, 0, 84, 0));
      P.push(wires([rect(-26, 22, 20, 142, -36.3)]));
      for (let y=34;y<=132;y+=12) P.push(wires([[[-22,y,-35],[16,y,-35]]]));
      P.push(box(3, 44, 4, 23, 84, -39));
      P.push(wires([rect(-26, 148, -6, 154, -36.3)], { accent:true }));
      [[-26,-30],[26,-30],[-26,30],[26,30]].forEach(([x,z]) => { P.push(drum(3.4, 3.4, 3, 12, x, 3.6, z, 'x')); P.push(box(3, 4, 3, x, 7, z)); });
      return P;
    },
    grain() {
      return [ellipsoid(2.8, 6.2, 2.4, 0, 0, 0, 12, 9), wires([[[0,-5.6,-2.25],[0,-2,-2.5],[0,2,-2.5],[0,5.6,-2.25]]])];
    },
    croissant() {
      const P = [];
      for (let i=-3;i<=3;i++){ const a=i*0.36, r=16, s=1 - Math.abs(i)*0.19;
        P.push(ellipsoid(5.4*s, 5*s, 6.2*s, Math.sin(a)*r, 0, -Math.cos(a)*r + r, 12, 8)); }
      return P;
    },
    rollingPin() {
      return [drum(4.2, 4.2, 40, 22, 0, 0, 0, 'x'), drum(1.4, 1.4, 10, 10, -25, 0, 0, 'x'), drum(1.4, 1.4, 10, 10, 25, 0, 0, 'x'),
              drum(2.2, 2.2, 2, 12, -31, 0, 0, 'x'), drum(2.2, 2.2, 2, 12, 31, 0, 0, 'x')];
    },
    whisk() {
      const L = [];
      for (let k=0;k<6;k++){ const b=k/6*Math.PI, pts=[];
        for (let i=0;i<=40;i++){ const f=i/40*TAU;                 // teardrop loop, pinched at the handle
          const u = 9.5*Math.sin(f)*Math.sin(f/2), v = 13*Math.cos(f);
          pts.push([Math.cos(b)*u, v, Math.sin(b)*u]); }
        L.push(pts); }
      return [wires(L), drum(1.7, 2.2, 18, 12, 0, 22, 0)];
    },
    baguette() {
      const P = [ellipsoid(5.5, 4.2, 42, 0, 0, 0, 14, 10)];
      const top = z => 4.2*Math.sqrt(Math.max(0, 1-(z/42)**2)) + 0.15;
      const cuts = []; for (let i=-2;i<=2;i++){ const z0=i*13-4, z1=i*13+4; cuts.push([[-2.6, top(z0)-0.4, z0],[0, top(i*13), i*13],[2.6, top(z1)-0.4, z1]]); }
      P.push(wires(cuts));
      return P;
    },
    loaf() {
      const P = [ellipsoid(16, 9, 11, 0, 0, 0, 18, 10)];
      P.push(wires([[[ -12, 8.3, 0],[12, 8.3, 0]]], { accent:true }));
      return P;
    },
    cup() {
      const P = [drum(4, 5.4, 8, 22, 0, 0, 0, 'y', { top:false }), drum(7.5, 7.5, 0.8, 26, 0, -4.4, 0)];
      const h = []; for (let i=0;i<=14;i++){ const a=-Math.PI/2 + i/14*Math.PI; h.push([5.6 + Math.cos(a)*2.6, Math.sin(a)*2.6 + 0.6, 0]); }
      P.push(wire(h));
      return P;
    }
  };

  /* ---- scene placement: anchored to page sections ---- */
  // [model, anchor, fy (0..1 down the section), fx (0..1 across viewport), size (fraction of vh), parallax, tone (0 ink → 1 paper), ry0, rx0, turn, idle, rz0]
  const DESK = [
    ['spiralMixer','#hero',   .50, .76, .66, .86, .12, -0.65, .20, 1.3, .55, 0],
    ['deckOven',   '#equipment', .52, .84, .42, .82, .40, -0.85, .18, 1.1, .35, 0],
    ['whisk',      '#equipment', .93, .90, .20, 1.12, .42,  0.2, .3, 2.6, .9, .7],
    ['standMixer', '#selected', .97, .10, .28, .80, .42, -0.9, .18, 1.5, .5, 0],
    ['combi',      '#why', .12, .82, .32, .84, .42, -0.7, .18, 1.2, .35, 0],
    ['proofer',    '#reviews-s', .08, .88, .36, .80, .46,  0.7, .14, 1.0, .3, 0],
    ['sheeter',    '#enquire', .19, .70, .62, .82, .40,  0.8, .35, 1.3, .4, 0]    // fills the space beside the enquiry heading
  ];
  // Phones: one column, so there is no room beside the copy. Each machine sits in the gap between two sections
  // instead, in the same order as on desktop. The last field is a pixel offset from the anchor point (fy 0 = the
  // section's top edge, where the gap is), so the placement does not depend on how long the copy runs.
  const MOB = [
    ['spiralMixer','#hero',       1, .74, .28, .93, .15, -0.65, .20, 1.3, .55, 0,  -130],   // under the hero buttons
    ['deckOven',   '#equipment',  0, .84, .10, .95, .40, -0.85, .18, 1.1, .35, 0,   118],   // beside the short "01 — Equipment" label
    ['whisk',      '#selected',   0, .80, .14, .95, .42,  0.2, .3, 2.6, .9, .7,     -14],   // above "02 — Selected machines"
    ['standMixer', '#why',        0, .26, .14, .93, .42, -0.9, .18, 1.5, .5, 0,      14],   // above "03 — Why us", left…
    ['combi',      '#why',        0, .76, .13, .93, .42, -0.7, .18, 1.2, .35, 0,     14],   // …and right
    ['proofer',    '#reviews-s',  0, .80, .17, .93, .46,  0.7, .14, 1.0, .3, 0,     -14],   // above "04 — Reviews"
    ['sheeter',    '#enquire',    0, .50, .32, .93, .40,  0.8, .35, 1.3, .4, 0,      14]    // above "05 — Enquire"
  ];

  const INK = [23,19,15], RED = [210,32,45], PAPER = [255,255,255];
  const mix = (c, t) => `rgb(${Math.round(c[0]+(PAPER[0]-c[0])*t)},${Math.round(c[1]+(PAPER[1]-c[1])*t)},${Math.round(c[2]+(PAPER[2]-c[2])*t)})`;

  let cv, ctx, W=0, H=0, DPR=1, objs=[], dust=[], reduced=false, FRONT=1, mouseX=0, mouseTX=0, spinV=0;

  // A depth sort alone buries anything mounted flat on a big face (door outlines, handles, displays, feet):
  // as the machine turns, half of it sorts behind the face's centre and the white fill paints over it.
  // So each part that sits on (or just behind the glass of) a box face, inside its outline, is tied to that face.
  function attach(parts) {
    for (const h of parts) {
      if (h.faces.length !== 6 || h.faces.some(f => f.length !== 4)) continue;          // hosts are boxes
      h.faces.forEach((f, fi) => {
        const n = newell(h.verts, f), ax = [0,1,2].reduce((m, i) => Math.abs(n[i]) > Math.abs(n[m]) ? i : m, 0);
        if (Math.abs(n[ax]) < .99) return;
        const d = n[0]*h.verts[f[0]][0] + n[1]*h.verts[f[0]][1] + n[2]*h.verts[f[0]][2];
        const lo = [0,1,2].map(i => Math.min(...f.map(j => h.verts[j][i])) + .3), hi = [0,1,2].map(i => Math.max(...f.map(j => h.verts[j][i])) - .3);
        for (const p of parts) {
          if (p === h || p.spin || h.host && h.host.part === p) continue;
          let lift = 1e9, top = -1e9, ok = true;
          for (const v of p.verts) {
            const s = n[0]*v[0] + n[1]*v[1] + n[2]*v[2] - d;
            if (s < -1.5 || s > 10) { ok = false; break; }
            for (let i=0;i<3;i++) if (i !== ax && (v[i] < lo[i] || v[i] > hi[i])) { ok = false; break; }
            if (!ok) break;
            lift = Math.min(lift, s); top = Math.max(top, s);
          }
          if (ok && (!p.host || top < p.host.top)) p.host = { part: h, fi, top }, p.lift = lift;
        }
      });
    }
    for (const p of parts) if (p.host) { const h = p.host.part; (h.kids = h.kids || {})[p.host.fi] = (h.kids[p.host.fi] || []).concat(p); }
  }

  // Whole parts are drawn in turn, ordered by separating planes: if every vertex of B lies outside one face plane
  // of A, the side of that plane the camera is on says which of the two is in front. Sorting single faces by depth
  // fails as soon as a big face sits next to a small part (a table beside the rollers, a head on a column).
  // An open bowl is split into its far wall and its near wall, and whatever sits inside it goes in between.
  function separate(A, B) {
    for (const [X, Y] of [[A, B], [B, A]]) {
      for (const f of X.faces) {
        const n = newell(X.verts, f), q = X.verts[f[0]];
        let ok = true;
        for (const v of Y.verts) if ((v[0]-q[0])*n[0] + (v[1]-q[1])*n[1] + (v[2]-q[2])*n[2] < -0.6) { ok = false; break; }
        if (ok) return { owner: X, other: Y, n, q };
      }
    }
    return null;
  }
  function planOrder(parts) {
    const free = parts.filter(p => !p.host), nodes = [], pairs = [];
    for (const p of free) {
      if (p.open) { p.nb = nodes.push({ p, sh: -1 }) - 1; p.nf = nodes.push({ p, sh: 1 }) - 1; }
      else p.nb = p.nf = nodes.push({ p, sh: 0 }) - 1;
    }
    for (let i=0;i<free.length;i++) for (let j=i+1;j<free.length;j++) {
      const A = free[i], B = free[j];
      if (!A.faces.length && !B.faces.length) continue;          // lines never hide lines
      const s = separate(A, B);
      if (s) pairs.push(s);
      else if (A.open !== B.open) pairs.push({ cup: A.open ? A : B, inside: A.open ? B : A });
    }
    return { nodes, pairs };
  }

  function build(list) {
    return list.map(([model, anchor, fy, fx, size, par, tone, ry0, rx0, turn, idle, rz0, dy = 0], idx) => {
      const parts = MODELS[model]();
      attach(parts);
      const plan = planOrder(parts);
      let mn=[1e9,1e9,1e9], mx=[-1e9,-1e9,-1e9];
      parts.forEach(p => p.verts.forEach(v => { for (let k=0;k<3;k++){ mn[k]=Math.min(mn[k],v[k]); mx[k]=Math.max(mx[k],v[k]); } }));
      const center = [(mn[0]+mx[0])/2, (mn[1]+mx[1])/2, (mn[2]+mx[2])/2];
      const dim = Math.max(mx[0]-mn[0], mx[1]-mn[1], mx[2]-mn[2]);
      return { model, anchor, fy, dy, fx, size, par, tone, ry0, rx0, rz0, turn, idle, parts, plan, center, dim, phase: idx*1.7, docY: 0,
               stroke: mix(INK, tone), accent: mix(RED, tone*0.7), lw: 1.15 + (1 - tone)*0.35 };
    });
  }

  function layout() {
    const sy = window.scrollY;
    objs.forEach(o => {
      const el = document.querySelector(o.anchor);
      if (!el) { o.docY = -1e6; return; }
      const r = el.getBoundingClientRect();
      o.docY = r.top + sy + o.fy * r.height + o.dy;
    });
  }

  function resize() {
    DPR = Math.min(window.devicePixelRatio || 1, 2);
    W = innerWidth; H = innerHeight;
    cv.width = Math.round(W*DPR); cv.height = Math.round(H*DPR);
    const mobile = W < 720;
    objs = build(mobile ? MOB : DESK);
    dust = makeMotes(mobile ? 32 : 66);
    layout();
  }

  function transform(o, part, cx, cy, k, P, cr, sr, cxr, sxr, czr, szr, t) {
    const vs = part.verts, n = vs.length;
    let sc=1, ss=0, axis=null, pv=null;
    if (part.spin && !reduced) { const a = t*part.spin.speed; sc=Math.cos(a); ss=Math.sin(a); axis=part.spin.axis; pv=part.spin.pivot; }
    for (let i=0;i<n;i++){
      let x=vs[i][0], y=vs[i][1], z=vs[i][2];
      if (axis) { x-=pv[0]; y-=pv[1]; z-=pv[2];
        if (axis==='y'){ const nx=x*sc+z*ss; z=-x*ss+z*sc; x=nx; }
        else if (axis==='z'){ const nx=x*sc-y*ss; y=x*ss+y*sc; x=nx; }
        else { const ny=y*sc-z*ss; z=y*ss+z*sc; y=ny; }
        x+=pv[0]; y+=pv[1]; z+=pv[2]; }
      x-=o.center[0]; y-=o.center[1]; z-=o.center[2];
      let nx = x*cr + z*sr; z = -x*sr + z*cr; x = nx;          // yaw
      let ny = y*cxr - z*sxr; z = y*sxr + z*cxr; y = ny;       // pitch
      nx = x*czr - y*szr; y = x*szr + y*czr; x = nx;           // roll
      const s = P/(P+z) * k;
      part.sx[i] = cx + x*s; part.sy[i] = cy - y*s; part.sz[i] = z;
    }
  }

  function drawObject(o, t, scrollY) {
    const k = o.size * (W < 720 ? Math.min(H, W * 2.164) : H) / o.dim;
    const par = reduced ? 1 : o.par;
    const cy = (o.docY - scrollY)*par + H*0.5*(1-par);
    const half = o.dim*k*0.75;
    if (cy < -half || cy > H + half) return;
    const cx = o.fx*W;
    const rel = (cy - H*0.5)/H;                                   // −½ … ½ as it crosses the screen
    const ry = o.ry0 + (reduced ? 0 : rel*o.turn + Math.sin(t*0.12*o.idle + o.phase)*0.35*o.idle + spinV + mouseX*0.12);
    const rx = o.rx0 + (reduced ? 0 : rel*0.35 + Math.sin(t*0.2 + o.phase)*0.04*o.idle);
    const rz = o.rz0 + (reduced ? 0 : Math.sin(t*0.15 + o.phase*1.3)*0.03*o.idle);
    const cr=Math.cos(ry), sr=Math.sin(ry), cxr=Math.cos(rx), sxr=Math.sin(rx), czr=Math.cos(rz), szr=Math.sin(rz);
    const P = o.dim*3.1;
    pre.length = 0;
    for (const p of o.parts) {
      transform(o, p, cx, cy, k, P, cr, sr, cxr, sxr, czr, szr, t);
      for (let fi=0; fi<p.faces.length; fi++) {
        const f = p.faces[fi]; let a=0;
        for (let i=0;i<f.length;i++){ const u=f[i], v=f[(i+1)%f.length]; a += p.sx[u]*p.sy[v] - p.sx[v]*p.sy[u]; }
        p.facing[fi] = (a*FRONT) > 0 ? 1 : 0;
      }
      if (p.host && !p.host.part.facing[p.host.fi]) pre.push(p);       // mounted on a face turned away: the body hides it, draw it first
    }                                                                  // (otherwise it is drawn right after its face, in drawPart)
    pre.sort((a, b) => meanZ(b) - meanZ(a));
    ctx.lineJoin = 'round'; ctx.lineCap = 'round';
    for (const p of pre) drawPart(o, p, 0);

    // order the parts: an edge a→b means a is drawn before b
    const { nodes, pairs } = o.plan, n = nodes.length, next = nodes.map(() => []), need = new Array(n).fill(0);
    const edge = (a, b) => { if (a !== b) { next[a].push(b); need[b]++; } };
    const rot = v => { let x=v[0], y=v[1], z=v[2]; let nx = x*cr + z*sr; z = -x*sr + z*cr; x = nx;
      let ny = y*cxr - z*sxr; z = y*sxr + z*cxr; y = ny; nx = x*czr - y*szr; y = x*szr + y*czr; return [nx, y, z]; };
    for (let i=0;i<n;i++) if (nodes[i].sh === -1) edge(i, nodes[i].p.nf);          // a bowl's far wall before its near wall
    for (const r of pairs) {
      if (r.cup) { edge(r.cup.nb, r.inside.nb); edge(r.inside.nf, r.cup.nf); continue; }
      const q = rot([r.q[0]-o.center[0], r.q[1]-o.center[1], r.q[2]-o.center[2]]), m = rot(r.n);
      const seen = -q[0]*m[0] - q[1]*m[1] + (-P - q[2])*m[2] > 0;   // camera (0,0,−P) on the outer side of the owner's plane?
      const [a, b] = seen ? [r.owner, r.other] : [r.other, r.owner];
      edge(a.nf, b.nb);
    }
    const depth = nodes.map(nd => meanZ(nd.p));
    const done = new Uint8Array(n);
    for (let c=0;c<n;c++) {
      let pick = -1;
      for (let i=0;i<n;i++) if (!done[i] && need[i] <= 0 && (pick < 0 || depth[i] > depth[pick])) pick = i;
      if (pick < 0) for (let i=0;i<n;i++) if (!done[i] && (pick < 0 || depth[i] > depth[pick])) pick = i;   // a cycle: farthest first
      done[pick] = 1; for (const j of next[pick]) need[j]--;
      drawPart(o, nodes[pick].p, nodes[pick].sh);
    }
  }

  const pre = [];
  const byDepth = (a, b) => b.z - a.z;
  const meanZ = p => { const z = p.sz; let s = 0; for (let i=0;i<z.length;i++) s += z[i]; return s / (z.length || 1); };
  // sh: 0 = the whole part as seen, -1 = only the faces turned away (inside of a bowl), 1 = only the faces turned to us
  function collect(p, out, sh = 0) {
    for (let fi=0; fi<p.faces.length; fi++) {
      const fr = p.facing[fi];
      if (sh === 0 ? !(fr || p.open) : sh === 1 ? !fr : fr) continue;
      const f = p.faces[fi]; let z=0;
      for (let i=0;i<f.length;i++) z += p.sz[f[i]];
      out.push({ p, fi, z: z/f.length });
    }
    if (sh !== -1) for (const w of p.wires) for (let i=0;i<w.length-1;i++) out.push({ p, w, i, z: (p.sz[w[i]] + p.sz[w[i+1]])/2 });
  }
  // One part (or one wall of a bowl): all its white fills first, then all its lines, so a neighbouring fill
  // or seam can never cover a line of the same part. Then whatever is mounted on its visible faces.
  function drawPart(o, p, sh) {
    if (p.open && sh === 0) { drawPart(o, p, -1); drawPart(o, p, 1); return; }
    const list = []; collect(p, list, sh); list.sort(byDepth);
    ctx.fillStyle = '#fff'; ctx.strokeStyle = '#fff'; ctx.lineWidth = DPR;
    for (const it of list) {
      if (it.w) continue;
      const f = p.faces[it.fi];
      ctx.beginPath(); ctx.moveTo(p.sx[f[0]]*DPR, p.sy[f[0]]*DPR);
      for (let i=1;i<f.length;i++) ctx.lineTo(p.sx[f[i]]*DPR, p.sy[f[i]]*DPR);
      ctx.closePath(); ctx.fill(); ctx.stroke();                     // the thin white stroke seals the hairline seam between faces
    }
    ctx.strokeStyle = p.accent ? o.accent : o.stroke; ctx.lineWidth = o.lw * DPR;
    ctx.beginPath();
    for (const it of list) {
      if (it.w) { ctx.moveTo(p.sx[it.w[it.i]]*DPR, p.sy[it.w[it.i]]*DPR); ctx.lineTo(p.sx[it.w[it.i+1]]*DPR, p.sy[it.w[it.i+1]]*DPR); continue; }
      for (const ei of p.faceEdges[it.fi]) {
        const e = p.edges[ei];
        const sil = e.f.length === 2 && p.facing[e.f[0]] !== p.facing[e.f[1]];
        if (e.hard || sil) { ctx.moveTo(p.sx[e.a]*DPR, p.sy[e.a]*DPR); ctx.lineTo(p.sx[e.b]*DPR, p.sy[e.b]*DPR); }
      }
    }
    ctx.stroke();
    // doors, handles, displays and feet mounted on a visible face go straight on top of it
    if (p.kids) for (const it of list) {
      const kids = !it.w && p.facing[it.fi] && p.kids[it.fi];
      if (kids) kids.slice().sort((a, b) => a.lift - b.lift).forEach(q => drawPart(o, q, 0));
    }
  }

  /* ---- motes: small dots and sparkles that rise up the screen, fade in, drift sideways and fade out,
     then start again somewhere new. Scrolling nudges them at their own depth. ---- */
  const MOTE_INK = [[210,32,45], [210,32,45], [210,32,45], [23,19,15], [150,138,124]];   // mostly brand red
  const hash = (a, b) => { const s = Math.sin(a*127.1 + b*311.7) * 43758.5453; return s - Math.floor(s); };
  function makeMotes(count) {
    return Array.from({ length: count }, (_, i) => {
      const r = k => hash(i + 1, k);
      return { i, dur: 9 + r(1)*8, off: r(2)*40, star: r(3) < .3, size: r(4), c: MOTE_INK[(r(5)*MOTE_INK.length)|0],
               drift: (r(6) - .5)*90, p: .08 + r(7)*.22, ph: r(8)*TAU };
    });
  }
  function sparkle(x, y, s) {   // four-point star
    const k = s*.3;
    ctx.beginPath(); ctx.moveTo(x, y - s);
    ctx.quadraticCurveTo(x + k, y - k, x + s, y); ctx.quadraticCurveTo(x + k, y + k, x, y + s);
    ctx.quadraticCurveTo(x - k, y + k, x - s, y); ctx.quadraticCurveTo(x - k, y - k, x, y - s);
    ctx.fill();
  }
  function drawMotes(t, scrollY) {
    for (const m of dust) {
      const time = t + m.off, cyc = Math.floor(time / m.dur), u = reduced ? .45 : time / m.dur - cyc;
      const x0 = hash(m.i + 7, cyc)*W, y0 = H*(.3 + hash(m.i + 13, cyc)*.85), rise = H*(.55 + hash(m.i + 29, cyc)*.35);
      const e = u < .5 ? 2*u*u : 1 - Math.pow(-2*u + 2, 2)/2;                 // ease-in-out, like the reference
      let y = y0 - rise*e - (reduced ? 0 : scrollY*m.p);
      y = ((y + 30) % (H + 60) + (H + 60)) % (H + 60) - 30;
      const x = x0 + m.drift*e + (reduced ? 0 : Math.sin(t*.7 + m.ph)*5);
      const a = u < .12 ? u/.12*.9 : u < .5 ? .9 - (u-.12)/.38*.2 : u < .85 ? .7 - (u-.5)/.35*.3 : .4*(1 - (u-.85)/.15);
      const sc = u < .5 ? .5 + u : 1 - (u-.5)*1.2;                              // grow to full size mid-flight, shrink away
      if (a <= 0.01) continue;
      const [cr, cg, cb] = m.c, X = x*DPR, Y = y*DPR;
      if (m.star) {
        ctx.fillStyle = `rgba(${cr},${cg},${cb},${a*.9})`;
        sparkle(X, Y, (3 + m.size*4)*sc*DPR);
      } else {
        const rad = (1 + m.size*1.8)*sc*DPR;
        ctx.fillStyle = `rgba(${cr},${cg},${cb},${a*.16})`;                   // soft glow
        ctx.beginPath(); ctx.arc(X, Y, rad*3, 0, TAU); ctx.fill();
        ctx.fillStyle = `rgba(${cr},${cg},${cb},${a})`;
        ctx.beginPath(); ctx.arc(X, Y, rad, 0, TAU); ctx.fill();
      }
    }
  }

  function frame(t, scrollY, vel) {
    spinV += ((reduced ? 0 : Math.max(-0.6, Math.min(0.6, vel*0.0022))) - spinV) * 0.06;
    mouseX += (mouseTX - mouseX) * 0.05;
    ctx.setTransform(1,0,0,1,0,0);
    ctx.clearRect(0, 0, cv.width, cv.height);
    drawMotes(t, scrollY);
    for (const o of objs) drawObject(o, t, scrollY);
  }

  function init(canvas, isReduced) {
    cv = canvas; ctx = cv.getContext('2d'); reduced = isReduced;
    // which screen winding is "facing the viewer"? measure it on a unit box.
    const b = box(2, 2, 2); const o = { center:[0,0,0] };
    transform(o, b, 0, 0, 1, 10, 1, 0, 1, 0, 1, 0, 0);
    let best = 0, bz = 1e9; b.faces.forEach((f, fi) => { const z = f.reduce((s, i) => s + b.sz[i], 0)/f.length; if (z < bz){ bz = z; best = fi; } });
    const f = b.faces[best]; let a = 0; for (let i=0;i<f.length;i++){ const u=f[i], v=f[(i+1)%f.length]; a += b.sx[u]*b.sy[v] - b.sx[v]*b.sy[u]; }
    FRONT = a > 0 ? 1 : -1;
    resize();
    addEventListener('resize', () => { resize(); });
    addEventListener('pointermove', e => { if (e.pointerType === 'mouse') mouseTX = (e.clientX / W - 0.5) * 2; }, { passive:true });
  }
  return { init, frame, layout, resize };
})();

/* =========================================================
   BOOT — runs once per page; the theme editor reloads on section changes.
   ========================================================= */
(function boot(){
  var root = document.querySelector('.la-home');
  var canvas = document.getElementById('la-art');
  if (!root || !canvas) return;
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var G = window.gsap, ST = window.ScrollTrigger;

  ART.init(canvas, reduced);

  var lenis = null;
  if (G && ST) G.registerPlugin(ST);
  if (G && ST && !reduced && window.Lenis && !(window.Shopify && Shopify.designMode)) {
    lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenis.on('scroll', ST.update);
    G.ticker.add(function (t) { lenis.raf(t * 1000); });
    G.ticker.lagSmoothing(0);
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"], a[href^="/#"]');
      if (!a) return;
      var id = a.getAttribute('href').replace(/^\//, '');
      if (id.length < 2) return;
      var el = document.querySelector(id);
      if (!el) return;
      e.preventDefault();
      lenis.scrollTo(el, { offset: -96, duration: 1.4 });
      history.replaceState(null, '', id);
    });
  }

  // headline + lede: split into letters (kept inside unbreakable word wrappers) for a
  // letter-by-letter fade-in. Screen readers get the plain text via aria-label.
  function splitLetters(el) {
    if (!el) return;
    var plain = el.cloneNode(true);                     // a <br> between lines counts as a space
    [].slice.call(plain.querySelectorAll('br')).forEach(function (b) { b.replaceWith(' '); });
    el.setAttribute('aria-label', plain.textContent.replace(/\s+/g, ' ').trim());
    function letters(text, into) {
      Array.from(text).forEach(function (chr) {
        var c = document.createElement('span'); c.className = 'ch'; c.textContent = chr; into.appendChild(c);
      });
    }
    function walk(node) {
      [].slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (tok) {
            if (!tok) return;
            if (/^\s+$/.test(tok)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span'); w.className = 'w'; w.setAttribute('aria-hidden', 'true');
            letters(tok, w); frag.appendChild(w);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') {
          walk(n);                       // keeps coloured spans (e.g. "bake.") around their letters
        }
      });
    }
    walk(el);
  }
  var h1 = root.querySelector('.hero h1');
  var lede = root.querySelector('.hero .lede');
  if (G && ST && !reduced) { splitLetters(h1); splitLetters(lede); }

  if (G && ST && !reduced) {
    root.classList.add('la-js');
    // letter-by-letter fade, left to right
    var fadeFrom = { opacity: 0 };
    var fadeTo = { opacity: 1, ease: 'power1.out' };
    G.fromTo('.la-home .hero h1 .ch', fadeFrom, Object.assign({ duration: 0.6, stagger: 0.035, delay: 0.15 }, fadeTo));
    G.fromTo('.la-home .hero .lede .ch', fadeFrom, Object.assign({ duration: 0.5, stagger: 0.006, delay: 1.0 }, fadeTo));
    G.from('.la-home .rv-hero:not(.lede)', { y: 22, opacity: 0, duration: 1, ease: 'power3.out', stagger: 0.12, delay: 0.55 });
    ST.batch('.la-home .rv', {
      start: 'top 92%', once: true,
      onEnter: function (els) { G.to(els, { opacity: 1, y: 0, duration: 0.95, ease: 'power3.out', stagger: 0.07, overwrite: true }); }
    });
  }

  // one render loop for the art layer
  var lastY = window.scrollY;
  function tick(time) {
    var y = lenis ? lenis.animatedScroll : window.scrollY;
    var vel = lenis ? lenis.velocity * 60 : (y - lastY) * 60; lastY = y;
    ART.frame(time, y, vel);
  }
  if (G) G.ticker.add(function (t) { tick(t); });
  else (function loop(ts) { tick(ts / 1000); requestAnimationFrame(loop); })(performance.now());

  if (ST) ST.addEventListener('refresh', ART.layout);
  var relayout = function () { if (ST) ST.refresh(); ART.layout(); };
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { setTimeout(relayout, 60); });
  addEventListener('load', relayout);
  // images in the machines grid and reviews change the page height as they land
  var ro = window.ResizeObserver ? new ResizeObserver(function () { ART.layout(); }) : null;
  if (ro) ro.observe(root);
})();


/* =========================================================
   ICONS — bakery icons, in ink and brand red, scattered around the
   content like a pattern. Each one pops in the first time it scrolls into
   view, slides at its own depth and turns as the page scrolls (clamped so it
   never reaches the copy), and wanders slowly while on screen.
   The fixed machine canvas sits above them.
   ========================================================= */
(function doodles(){
  var root = document.querySelector('.la-home');
  if (!root) return;
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  // The icons are cut straight from a bakery icon sheet into one 4x4 sprite (Shopify Files). It is used as a mask,
  // so .r / .b paint each one red or black. MAIN lists the sprite cells in reading order.
  var SPRITE = '/cdn/shop/files/bakery-icons.png?v=1790511885';
  var MAIN = ['loaf','pretzel','buns','muffin','donut','swissroll','wheat','pie','icecream','cupcake','cake','bread','croissant','toast','baguettes','tiercake'];
  var MAXP = matchMedia("(max-width:719px)").matches ? 24 : 80;
  var EXCL = '.hero .wrap > *, .scrollcue, .la-brandsx, .eyebrow, .la-h, .lede, .rows, .head-tools, .boxes';
  var layer = document.createElement('div');
  layer.className = 'la-doodles'; layer.setAttribute('aria-hidden', 'true');
  layer.style.setProperty('--la-ico', 'url("' + SPRITE + '")');
  root.insertBefore(layer, root.firstChild);

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) e.target.classList.add('drawn', 'live');
      else e.target.classList.remove('live');
    });
  }, { rootMargin: '0px 0px -6% 0px' }) : null;

  function rng(seed) { return function () { seed |= 0; seed = seed + 0x6D2B79F5 | 0; var t = Math.imul(seed ^ seed >>> 15, 1 | seed); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }

  var lastKey = '', SEED = (Math.random() * 4294967296) >>> 0;
  function place() {
    var W = root.clientWidth, H = root.offsetHeight, rt = root.getBoundingClientRect();
    var key = W + 'x' + Math.round(H / 40);
    if (key === lastKey) return; lastKey = key;
    if (io) io.disconnect();
    layer.innerHTML = '';
    var mobile = W < 720, pad = mobile ? 12 : 26, padY = pad + MAXP * (mobile ? 1 : .75);
    var rects = [].map.call(root.querySelectorAll(EXCL), function (el) {
      var r = el.getBoundingClientRect();
      return [r.left - rt.left - pad, r.top - rt.top - padY, r.right - rt.left + pad, r.bottom - rt.top + padY];
    });
    var hero = root.querySelector('.hero');
    if (hero && !mobile) rects.push([W * .56, 60, W * .98, hero.offsetHeight * .96]);   // the big mixer
    // a fresh layout on every visit; the seed is kept for the visit so re-layouts (fonts, images) stay put
    var R = rng(SEED), cell = mobile ? 64 : 84, cand = [];
    // 1) lots of candidate spots in the free space around the copy
    for (var y = 70; y < H - 40; y += cell) {
      for (var x = 0; x < W; x += cell) {
        var s = (mobile ? 36 : 46) + R() * (mobile ? 16 : 34);
        var px = x + R() * cell - s / 2, py = y + R() * cell - s / 2;
        if (px < 2 || px + s > W - 2) continue;
        var hit = false;
        for (var k = 0; k < rects.length && !hit; k++) { var q = rects[k]; hit = px < q[2] && px + s > q[0] && py < q[3] && py + s > q[1]; }
        if (!hit) cand.push({ x: px, y: py, s: s, cx: px + s / 2, cy: py + s / 2 });
      }
    }
    // 2) spread them evenly: each pick is the farthest of a few random spots from everything placed so far
    var max = Math.min(cand.length, Math.round(H / (mobile ? 560 : 180))), pick = [], dmin = [], i, j;
    for (i = 0; i < cand.length; i++) dmin[i] = 1e18;
    for (var cur = (R() * cand.length) | 0; cur >= 0 && pick.length < max;) {
      var c = cand[cur]; pick.push(c); dmin[cur] = -1;
      for (i = 0; i < cand.length; i++) if (dmin[i] >= 0) { var dx = cand[i].cx - c.cx, dy = cand[i].cy - c.cy, dd = dx * dx + dy * dy; if (dd < dmin[i]) dmin[i] = dd; }
      cur = -1;
      for (j = 0, best = -1; j < 12; j++) { i = (R() * cand.length) | 0; if (dmin[i] > best) { best = dmin[i]; cur = i; } }
      if (cur < 0) for (i = 0; i < cand.length; i++) if (dmin[i] > best) { best = dmin[i]; cur = i; }
    }
    // 3) deal icon types and colours from shuffled decks so every glyph shows up and red/black stay balanced
    function shuffle(a) { for (var z = a.length - 1; z > 0; z--) { var r = (R() * (z + 1)) | 0, t = a[z]; a[z] = a[r]; a[r] = t; } return a; }
    var deck = [], reds = [], best;
    pick.sort(function (a, b) { return a.cy - b.cy; });
    for (i = 0; i < pick.length; i++) reds.push(i < Math.round(pick.length * .45));
    shuffle(reds);
    var html = pick.map(function (c, n) {
      if (!deck.length) deck = shuffle(MAIN.slice());
      var cell = MAIN.indexOf(deck.pop()), red = reds[n];
      var o = red ? .85 + R() * .15 : .78 + R() * .2;
      var f = 10 + R() * 8, depth = (R() < .5 ? -1 : 1) * (.14 + R() * .26), spin = (R() < .5 ? -1 : 1) * (.02 + R() * .04);
      return '<i class="dd ' + (red ? 'r' : 'b') + '" data-y="' + c.cy.toFixed(0) + '" data-p="' + depth.toFixed(3) + '" data-s="' + spin.toFixed(3) +
        '" style="--mp:' + (cell % 4) * 100 / 3 + '% ' + ((cell / 4) | 0) * 100 / 3 + '%;left:' + c.x.toFixed(1) + 'px;top:' + c.y.toFixed(1) + 'px;width:' + c.s.toFixed(1) + 'px;height:' + c.s.toFixed(1) +
        'px;--r:' + ((R() * 44 - 22) | 0) + 'deg;--o:' + o.toFixed(2) + ';--d:' + (R() * .35).toFixed(2) + 's;--f:' + f.toFixed(1) + 's;--ad:-' + (R() * f).toFixed(1) +
        's;--dx:' + (8 + R() * 12).toFixed(0) + 'px;--dy:' + (6 + R() * 10).toFixed(0) + 'px"></i>';
    });
    layer.innerHTML = html.join('');
    items = [].map.call(layer.children, function (el) {
      if (reduced || !io) el.classList.add('drawn'); else io.observe(el);
      return { el: el, y: +el.getAttribute('data-y'), p: +el.getAttribute('data-p'), s: +el.getAttribute('data-s'), last: 1e9 };
    });
  }

  // scroll: each icon slides at its own depth (clamped to MAXP) and turns as it crosses the screen
  var items = [];
  function drift() {
    if (!reduced && items.length) {
      var top = root.getBoundingClientRect().top, vh = innerHeight, mid = vh / 2;
      for (var i = 0; i < items.length; i++) {
        var it = items[i], sy = top + it.y;                      // icon centre on screen
        if (sy < -300 || sy > vh + 300) continue;
        var rel = sy - mid, d = Math.max(-MAXP, Math.min(MAXP, rel * it.p));
        if (Math.abs(d - it.last) > .4) {
          it.el.style.translate = '0 ' + d.toFixed(1) + 'px';
          it.el.style.rotate = (rel * it.s).toFixed(1) + 'deg';
          it.last = d;
        }
      }
    }
    requestAnimationFrame(drift);
  }
  requestAnimationFrame(drift);
  var t = 0, again = function () { clearTimeout(t); t = setTimeout(place, 250); };
  place();
  addEventListener('load', again);
  addEventListener('resize', again);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(again);
  if (window.ResizeObserver) new ResizeObserver(again).observe(root);
})();

})();
